//all constants used in the code
export const Variables = {
    englishLanguageCode: 'en',
    finnishLanguageCode: 'fi',
    swedishLanguageCode: 'sv',
    allowedLanguageArray: ['en', 'fi', 'sv'],
    languageQueryParameter: 'language',
    TicketIDQueryParameter: 'TicketID',
    RedirectUriQueryParameter: 'redirect_uri',
    InvalidString: 'INVALID',
    preloginBaseUrl: {
        syst: 'https://syst-auth.danskebank.fi/security/auth/api/auth/v1/login?oidcClient=webpayment-fi&redirectUri=%2Fsecurity%2Fauth%2Fapi%2Fauth%2Fwebpayment-fi%2Fsignin',
        prod: 'https://auth.danskebank.fi/security/auth/api/auth/v1/login?oidcClient=webpayment-fi&redirectUri=%2Fsecurity%2Fauth%2Fapi%2Fauth%2Fwebpayment-fi%2Fsignin'
    },
    currentLanguage: '&currentLanguage=',
    destinationBaseUrl: {
        syst: 'https%3A%2F%2Fsyst-webpayments.danskebank.fi%2F',
        prod: 'https%3A%2F%2Fwebpayments.danskebank.fi%2F'
    },
    ticketIdEncodedQueryParameter: '%2Flogon%3FTicketID%3D',
    ticketIdDecoded: "&TicketID=",
    destinationUrl: '&destinationUrl=',
    postLegacyLoginUrl: {
        syst: "https://syst-auth.danskebank.fi/security/auth/api/auth/v1/legacy-login?lhp=EB",
        prod: "https://auth.danskebank.fi/security/auth/api/auth/v1/legacy-login?lhp=EB"
    },
    postLegacyLogoutUrl: {
        syst: "https://syst-auth.danskebank.fi/security/auth/api/auth/v1/logout",
        prod: "https://auth.danskebank.fi/security/auth/api/auth/v1/logout"
    },
    httpsString: 'https://',
    WebpaymentsEnglishBaseUrl: {
        syst: "syst-ebanking2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true",
        prod: "ebanking2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsFinnishBaseUrl: {
        syst: "syst-verkkopankki2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true",
        prod: "verkkopankki2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsSwedishBaseUrl: {
        syst: "syst-webbank2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true",
        prod: "webbank2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsRoleSelectionEnglishBaseUrl: {
        syst: "syst-ebanking2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true",
        prod: "ebanking2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsRoleSelectionBusinessBaseUrl: {
        syst: "syst-business2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true",
        prod: "business2.danskebank.fi/WP/WebPayment/WebPayment.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsRoleSelectionFinnishBaseUrl: {
        syst: "syst-verkkopankki2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true",
        prod: "verkkopankki2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true"
    },
    WebpaymentsRoleSelectionSwedishBaseUrl: {
        syst: "syst-webbank2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true",
        prod: "webbank2.danskebank.fi/WP/AdmSys/ChooseAccessAgreement.aspx?secsystem=JS&isFrameless=true"
    },
    getlegacyAgreement: { 
        syst: "https://syst-auth.danskebank.fi/security/auth/api/auth/v1/user/legacy-agreements",
        prod: "https://auth.danskebank.fi/security/auth/api/auth/v1/user/legacy-agreements"
    },
    setlegacyRole: { 
        syst: "https://syst-auth.danskebank.fi/security/auth/api/auth/v1/user/agreements",
        prod: "https://auth.danskebank.fi/security/auth/api/auth/v1/user/agreements"
    },
    legacysetasactive: "legacy-set-as-active",
    setDefaultfalse:"setDefault=false",
    removeDefaultfalse:"removeDefault=false",
    WebpaymentsContextEnglishString: {
        syst: "&gsUserContextJN=J&secsystem=JS",
        prod: "&gsUserContextJN=J&secsystem=JS"
    },
    WebpaymentsContextFinnishString: {
        syst: "&gsUserContextJN=J&secsystem=J3",
        prod: "&gsUserContextJN=J&secsystem=J3"
    },
    WebpaymentsContextSwedishString: {
        syst: "&gsUserContextJN=J&secsystem=J2",
        prod: "&gsUserContextJN=J&secsystem=J2"
    },
    ErrorMainHeadingText: {
        PreLogonError: {
            en: "Something went wrong",
            fi: "Jokin meni vikaan",
            sv: "Något gick fel"
        },
        PostLogonError: {
            en: "Something went wrong",
            fi: "Jokin meni vikaan",
            sv: "Något gick fel"
        },
        NoPageFound: {
            en: "Page not found.",
            fi: "Sivua ei ole olemassa",
            sv: "Sidan finns inte"
        },
        GenericError: {
            en: "Something went wrong",
            fi: "Jokin meni vikaan",
            sv: "Något gick fel"
        }
    },
    ErrorSubHeadingText: {
        PreLogonError: {
            en: "An error occured while loading your data",
            fi: "Virhe tietojen latauksessa",
            sv: "Ett fel uppstod när dina data laddades"
        },
        PostLogonError: {
            en: "There was an error while logging you in",
            fi: "Kirjautumisessa tapahtui virhe",
            sv: "Det uppstod ett fel när du loggade in"
        },
        NoPageFound: {
            en: "The link you are trying to access doesn't exist.",
            fi: "Linkkiä jota yrität käyttää ei ole olemassa",
            sv: "Länken du försöker användä finns inte"
        },
        GenericError: {
            en: "Technical error has occurred. We are working on solving this issue. Please try again.",
            fi: "Tapahtui virhe. Pyrimme ratkaisemaan ongelman mahdollisimman pian. Yritä uudelleen.",
            sv: "Tyvärr har ett fel uppstått. Vi arbetar på att lösa problemet. Vänligen försök igen."
        }
    }
}

//Providing the different language translations for different type of errors
export function ErrorTranslation(language: string, errorType: string): { MainHeading: string, SubHeading: string } {
    var MainHeading: string = "";
    var SubHeading: string = "";
    switch (errorType) {
        case "PreLogonError":
            switch (language) {
                case "en":
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.en;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.en;
                    break;
                case "fi":
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.fi;
                    break;
                case "sv":
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.sv;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.sv;
                    break;
                default:
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.fi;
                    break;
            }
            break;
        case "PostLogonError":
            switch (language) {
                case "en":
                    MainHeading = Variables.ErrorMainHeadingText.PostLogonError.en;
                    SubHeading = Variables.ErrorSubHeadingText.PostLogonError.en;
                    break;
                case "fi":
                    MainHeading = Variables.ErrorMainHeadingText.PostLogonError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.PostLogonError.fi;
                    break;
                case "sv":
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.sv;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.sv;
                    break;
                default:
                    MainHeading = Variables.ErrorMainHeadingText.PreLogonError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.PreLogonError.fi;
                    break;
            }
            break;
        case "NoPageFound":
            switch (language) {
                case "en":
                    MainHeading = Variables.ErrorMainHeadingText.NoPageFound.en;
                    SubHeading = Variables.ErrorSubHeadingText.NoPageFound.en;
                    break;
                case "fi":
                    MainHeading = Variables.ErrorMainHeadingText.NoPageFound.fi;
                    SubHeading = Variables.ErrorSubHeadingText.NoPageFound.fi;
                    break;
                case "sv":
                    MainHeading = Variables.ErrorMainHeadingText.NoPageFound.sv;
                    SubHeading = Variables.ErrorSubHeadingText.NoPageFound.sv;
                    break;
                default:
                    MainHeading = Variables.ErrorMainHeadingText.NoPageFound.fi;
                    SubHeading = Variables.ErrorSubHeadingText.NoPageFound.fi;
                    break;
            }
            break;
        default:
            switch (language) {
                case "en":
                    MainHeading = Variables.ErrorMainHeadingText.GenericError.en;
                    SubHeading = Variables.ErrorSubHeadingText.GenericError.en;
                    break;
                case "fi":
                    MainHeading = Variables.ErrorMainHeadingText.GenericError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.GenericError.fi;
                    break;
                case "sv":
                    MainHeading = Variables.ErrorMainHeadingText.GenericError.sv;
                    SubHeading = Variables.ErrorSubHeadingText.GenericError.sv;
                    break;
                default:
                    MainHeading = Variables.ErrorMainHeadingText.GenericError.fi;
                    SubHeading = Variables.ErrorSubHeadingText.GenericError.fi;
                    break;
            }
    }
    return {
        MainHeading: MainHeading,
        SubHeading: SubHeading
    };
}

//check whether the URL where react is running is Local, in SYST or PROD
export function isLocal(host: string): boolean {
    return host.includes('localhost');
}

export function isSyst(host: string): boolean {
    //return (host.includes('syst') || host.includes('testing'));
    if (host.includes('syst') || host.includes('testing'))
    {
        return true;
    }
    else {
        return false;
    }
}

export function isProd(host: string): boolean {

    if (host.includes('syst') || host.includes('testing') || host.includes('localhost')) {
        return false;
    }
    else {
        return true;
    }
    //return host.includes('prod');
}
